<template>
	<div class="container">
		<div class="slider">
			<div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
				<div class="carousel-loading" v-if="loading || loadingSeriesAndVolumes"></div>
				<div v-else>
					<div class="carousel-indicators">
						<button
							type="button"
							data-bs-target="#carouselExampleIndicators"
							class="carousel-indicators-button"
							:data-bs-slide-to="i"
							aria-current="true"
							:aria-label="`Slide ${i + 1}`"
							v-for="(s, i) in sliders"
							:key="i"
							:class="{ active: i === 0 }"></button>
					</div>
					<div class="carousel-inner">
						<div
							class="carousel-item"
							v-for="(slider, i) in sliders"
							:key="i"
							:class="{ active: i === 0 }">
							<img :src="slider.image" class="d-block w-100" alt="..." />
							<div>
								<div class="slider-t-b ck-content" v-html="slider.description"></div>
							</div>
						</div>
					</div>
					<button
						class="carousel-control-prev"
						type="button"
						data-bs-target="#carouselExampleIndicators"
						data-bs-slide="prev">
						<span class="carousel-control-prev-icon" aria-hidden="true"></span>
						<span class="visually-hidden">Previous</span>
					</button>
					<button
						class="carousel-control-next"
						type="button"
						data-bs-target="#carouselExampleIndicators"
						data-bs-slide="next">
						<span class="carousel-control-next-icon" aria-hidden="true"></span>
						<span class="visually-hidden">Next</span>
					</button>
				</div>
			</div>
			<div class="static">
				<div>
					<div>{{ Visits.toFixed() }}</div>
					<div>{{ $t('home.statics.visitors') }}</div>
				</div>
				<div>
					<div>{{ Articles.toFixed() }}</div>
					<div>{{ $t('home.statics.articles') }}</div>
				</div>
				<div>
					<div>{{ Volume.toFixed() }}</div>
					<div>{{ $t('home.statics.volume') }}</div>
				</div>
				<div>
					<div>{{ Series.toFixed() }}</div>
					<div>{{ $t('home.statics.series') }}</div>
				</div>
			</div>
		</div>

		<div class="series">
			<div class="title">{{ $t('series') }}</div>

			<!-- loader -->
			<loader v-if="loading || loadingSeriesAndVolumes" />
			<!-- series -->
			<div v-else class="s-main">
				<series-card class="s-item" v-for="serie in series" :serie="serie" :key="serie.id" />
			</div>
		</div>
		<div class="news">
			<div class="title">{{ $t('home.last-news') }}</div>

			<!-- loader -->
			<loader v-if="loading || loadingSeriesAndVolumes" />
			<!-- news -->
			<div v-else class="n-main row mx-0">
				<event-card
					class="n-item col-lg-3 col-md-6 col-12"
					v-for="newsIndex in news.slice(0, 4)"
					:key="newsIndex.id"
					:event="newsIndex" />
			</div>
		</div>
	</div>
</template>

<script>
import EventCard from '@/components/EventCard';
import SeriesCard from '@/components/SeriesCard';
import Loader from '@/components/Loader';
import { mapState } from 'vuex';
export default {
	props: ['loadingSeriesAndVolumes'],

	components: {
		EventCard,
		SeriesCard,
		Loader,
	},

	data() {
		return {
			loading: true,
			maxSeries: 0,
			Series: 0,
			maxArticles: 0,
			Articles: 0,
			maxVolumes: 0,
			Volume: 0,
			maxVisits: 0,
			Visits: 0,
		};
	},

	watch: {
		loadingSeriesAndVolumes() {
			this.$nextTick(() => {
				document.querySelectorAll('.s-item').forEach((e) => {
					this.enteri(e);
				});
			});
		},
	},

	computed: {
		...mapState({
			series: (state) => state.series.series,
			news: (state) => state.news.news,
			statisticsVolumes: (state) => state.statistics.volumes,
			statisticsArticles: (state) => state.statistics.articles,
			statisticsSeries: (state) => state.statistics.series,
			statisticsVisits: (state) => state.statistics.visits,
			sliders: (state) => state.sliders.sliders,
		}),
	},

	methods: {
		async runStatics() {
			var i = 0;
			const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
			while (i < 200) {
				i++;
				this.Series += this.maxSeries / 200;
				this.Articles += this.maxArticles / 200;
				this.Visits += this.maxVisits / 200;
				this.Volume += this.maxVolumes / 200;
				await delay(10);
			}
			this.Series = this.maxSeries;
			this.Articles = this.maxArticles;
			this.Visits = this.maxVisits;
			this.Volume = this.maxVolumes;
		},
		enteri(ele) {
			const list = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting >= 0.5) {
						ele.classList.add('start');
					}
				});
			});
			list.observe(ele);
		},
	},

	mounted() {
		Promise.all([
			this.$store.dispatch('news/fetchAll'),
			this.$store.dispatch('statistics/fetchVolumes'),
			this.$store.dispatch('statistics/fetchArticles'),
			this.$store.dispatch('statistics/fetchSeries'),
			this.$store.dispatch('statistics/fetchVisits'),
			this.$store.dispatch('sliders/fetchAll'),
		])
			.then(() => {
				this.maxSeries = this.statisticsSeries;
				this.maxArticles = this.statisticsArticles;
				this.maxVolumes = this.statisticsVolumes;
				this.maxVisits = this.statisticsVisits;
			})
			.then(() => {
				this.loading = false;
				this.runStatics();
			})
			.finally(() => {
				this.$nextTick(() => {
					document.querySelectorAll('.s-item').forEach((e) => {
						this.enteri(e);
					});
				});
			});
	},
};
</script>

<style scoped>
.container > .slider,
.container > .series,
.container > .news {
	margin: 0 50px;
}
.slider {
	margin: 0 !important;
	position: relative;
}
.carousel-item {
	height: 500px;
}
.carousel-item img {
	height: 100%;
	object-fit: cover;
}
.carousel-item > div {
	width: 100%;
	height: 100%;
	padding: 0 50px;
	background: #0008;
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.slider-t-u {
	margin-top: 120px;
	font-size: 22px;
	color: white;
	font-family: changeMedium;
	text-align: center;
}
.slider-t-b {
	font-size: 44px;
	color: white;
	font-family: changeBold;
	text-align: center;
}
.carousel-indicators {
	bottom: 100px;
}
.static {
	position: absolute;
	bottom: 0;
	width: 100%;
	display: flex;
	background: #000b;
	justify-content: space-between;
	padding: 20px 200px;
}
.static > div {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100px;
}
@media (max-width: 400px) {
	.static {
		flex-wrap: wrap;
	}
	.static > div {
		width: 50%;
		margin: 10px 0;
	}
}
.static > div > div {
	color: white;
	line-height: 30px;
	font-family: changeMedium;
}
.static > div > div:first-child {
	font-size: 44px;
}
.static > div > div:last-child {
	font-size: 20px;
	line-height: 25px;
}
.title {
	text-align: center;
	font-size: 30px;
	font-family: changeBold;
	color: var(--green-color);
	padding: 20px 0 10px;
}
.series {
	padding: 50px 0 0;
}
.s-main {
	display: grid;
	grid-template-columns: repeat(3, minmax(min-content, 333px));
	justify-content: center;
	row-gap: 20px;
	column-gap: 30px;
}
.s-item {
	visibility: hidden;
	transform: translateY(50px);
	transition: 500ms ease-in;
}
.s-item.start {
	transform: translateY(0);
	visibility: visible;
}
.n-main {
	padding: 50px;
}
.n-item {
	padding: 0 10px;
	max-width: 310px;
	margin: auto;
}
@media only screen and (max-width: 992px) {
	.s-main {
		grid-template-columns: repeat(auto-fit, 250px);
		column-gap: 20px;
	}

	.container > div {
		margin: 0 10px;
	}

	.series {
		padding-top: 20px;
	}
	.n-main {
		padding: 30px 0;
	}
	.n-item {
		max-width: 400px;
		padding-bottom: 30px;
	}
	.static {
		padding: 20px 30px;
	}
	.static > div > div:first-child {
		font-size: 33px;
	}
	.static > div > div:last-child {
		font-size: 14px;
		line-height: 10px;
	}
}
@media only screen and (max-width: 768px) {
	.slider-t-u {
		margin-top: 120px;
		font-size: 18px;
	}
	.slider-t-b {
		font-size: 36px;
	}
}
@media only screen and (max-width: 890px) and (min-width: 620px) {
	.s-item:last-child {
		grid-column-start: 1;
		grid-column-end: 3;
		margin: auto;
		width: 50%;
	}
}
.carousel-loading {
	height: 500px;
	animation: carousel-loading 1.8s ease-in-out infinite;
	background-color: #e7e3e4;
	background-image: linear-gradient(120deg, transparent 45%, #f7f7f7 50%, transparent 55%);
	background-size: 400%;
	background-repeat: no-repeat;
}
@keyframes carousel-loading {
	0% {
		background-size: 0%;
		background-color: #e7e3e4;
	}
	50% {
		background-color: #c2c2c2;
		background-size: 400%;
	}
	100% {
		background-color: #e7e3e4;
	}
}
</style>
<style>
.slider-t-b * {
	color: inherit;
	font-size: inherit;
}
</style>
